import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrudImplementation} from '@shared/services/crud-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudTranslationService  extends CrudImplementation {
  protected url = '/v1/admin/translations';

  /**
   * TODO
   * use client crud
   */
  getClientList(): Observable<any> {
    const url = '/v1/admin/dropdown/clients';
    return this.http.get(this.serverRoot + url);
  } // getClientList

}
